import $ from 'jquery';

$(window)
	.scroll(function () {
		var scrollDistance = $(window).scrollTop();
		var offsetTop = $('.c-header').outerHeight();

		if ($('.js-side').length > 0) {
			if ($(window).outerWidth() < 751) {
				if (scrollDistance > $('.js-navi').position().top - offsetTop) {
					$('.js-side').addClass('is-show');
				} else {
					$('.js-side').removeClass('is-show');
				}
			}
		}
	})
	.scroll();
